import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FormContainer from '../shared/FormContainer';
import CustomInput from '../shared/CustomInput';
import Button from '../shared/Button';
import { Api } from '../../network/api';

const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
  });
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
        if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setErrors({});
    console.log("formData",formData);
    
    try {
      const response = await Api.forgotPassword(formData);
      console.log("response",response);
      
      if (response?.data?.success || response?.status === 200) {
        setMessage(response?.data?.message);
        setSuccess(true);
      } else {
        setErrors({ general: 'Failed to send reset email. Please try again.' });
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      const errorMessage = error?.response?.data?.detail || 'Failed to send reset email. Please try again.';
      setErrors({ general: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/login');
  };

  if (success) {
    return (
      <FormContainer
        title="Email Sent"
        subtitle="Check your inbox"
      >
        <div className="space-y-6">
          <div className="bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded-xl text-left animate-fadeInUp">
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              {message}
            </div>
          </div>

          <div className="text-center space-y-4 animate-fadeInUp animation-delay-100">
            <p className="text-sm text-gray-600">
              We've sent a password reset link to <strong>{formData.email}</strong>
            </p>
            <p className="text-xs text-gray-500">
              Please check your email and click the link to reset your password. 
              The link will expire in 10 minutes.
            </p>
          </div>

          <div className="animate-fadeInUp animation-delay-200">
            <Button
              type="button"
              onClick={handleBackToLogin}
              className="w-full hover-lift"
              size="large"
            >
              Back to Login
            </Button>
          </div>

          <div className="text-center animate-fadeInUp animation-delay-300">
            <p className="text-sm text-gray-600">
              Didn't receive the email?{' '}
              <button
                type="button"
                onClick={() => setSuccess(false)}
                className="font-medium text-blue-600 hover:text-blue-500 transition-colors duration-200 hover:underline"
              >
                Try again 
              </button>
            </p>
          </div>
        </div>
      </FormContainer>
    );
  }

  return (
    <FormContainer
      title="Forgot Password"
      subtitle="Enter your email to reset your password"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        {errors.general && (
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-xl text-left animate-shake">
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {errors.general}
            </div>
          </div>
        )}

        <div className="animate-fadeInUp animation-delay-100">
          <CustomInput
            type="email"
            name="email"
            label="Email Address"
            placeholder="Enter your email address"
            value={formData.email}
            onChange={handleInputChange}
            error={errors.email}
            required
            autoComplete="email"
          />
        </div>

        <div className="animate-fadeInUp animation-delay-200">
          <Button
            type="submit"
            loading={loading}
            disabled={loading}
            className="w-full hover-lift"
            size="large"
          >
            Send Reset Link
          </Button>
        </div>

        <div className="text-center animate-fadeInUp animation-delay-300">
          <p className="text-sm text-gray-600">
            Remember your password?{' '}
            <button
              type="button"
              onClick={handleBackToLogin}
              className="font-medium text-blue-600 hover:text-blue-500 transition-colors duration-200 hover:underline"
            >
              Back to login
            </button>
          </p>
        </div>
      </form>
    </FormContainer>
  );
};

export default ForgotPasswordForm; 